import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../redux/store";
import {
  addSalaryMasterAction,
  editSalaryMasterAction,
  fetchSalariesMasterAction,
  deleteSalaryMasterAction,
} from "../redux/actions/salaryMasterAction";
import { SalaryMaster } from "../types/salaryMaster";
import Modal from "../components/Modal";
import CollapseCard from "../components/custom/CollapseCard";
import PageContainer from "../components/custom/PageContainer";
import Main from "../components/custom/Main";
import { StoreState } from "../redux/reducers";
import { useToast } from "../components/toast/ToastProvider";
import SalaryMasterForm from "../components/SalaryMasterForm";
import SalesMasterList from "../components/SalaryMasterList";
import SalarMasterFilter from "../components/SalarMasterFilter";

const SalaryMasterPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toast = useToast();

  const salaries = useSelector((state: StoreState) => state.salaryMaster.all);
  console.log(salaries);

  const [selectedSalary, setSelectedSalary] = useState<SalaryMaster | null>(
    null,
  );

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    dispatch(fetchSalariesMasterAction()).finally(() => setLoading(false));
  }, [dispatch]);

  const handleSave = async (data: SalaryMaster) => {
    setLoading(true);
    try {
      if (selectedSalary) {
        await dispatch(editSalaryMasterAction(data.id, data));
        toast("Salary updated successfully");
      } else {
        await dispatch(addSalaryMasterAction(data));
        toast("Salary added successfully");
      }
      await dispatch(fetchSalariesMasterAction());
      setSelectedSalary(null);
      setShowModal(false);
    } catch (error) {
      toast("Error saving salary");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this salary?")) {
      setLoading(true);
      try {
        await dispatch(deleteSalaryMasterAction(id));
        toast("Salary deleted successfully");
        await dispatch(fetchSalariesMasterAction());
      } catch (error) {
        toast("Error deleting salary");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleEdit = (item: SalaryMaster) => {
    setSelectedSalary(item);
    setShowModal(true);
  };

  const [filters, setFilters] = useState({
    employeeId: "",
  });

  const [filterEmp, setFilterEmp] = useState<SalaryMaster[]>([]);
  const employees = useSelector((state: StoreState) => state.employee);

  useEffect(() => {
    setFilterEmp(salaries);
  }, [salaries]);

  const handleFilterChange = (newFilters: typeof filters) => {
    setFilters(newFilters);
    const filtered = salaries.filter((emp) => {
      const employeeIds =
        !newFilters.employeeId || emp.employeeId === newFilters.employeeId;
      return employeeIds;
    });
    setFilterEmp(filtered);
  };

  const handleResetFilters = () => {
    const resetValues = { employeeId: "" };

    setFilters(resetValues);
    setFilterEmp(salaries);
  };
  return (
    <Main>
      <PageContainer
        title="Salary Master"
        onButtonClick={() => setShowModal(true)}
        buttonText={loading ? "Loading..." : "ADD"}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedSalary(null);
          }}
          headerText={selectedSalary ? "Update Salary" : "Add Salary"}
        >
          <SalaryMasterForm 
          initialData={selectedSalary} 
          onSave={handleSave}
          salaries={salaries} />
        </Modal>

        <>
          <CollapseCard title="SalaryMaster Filter">
            <SalarMasterFilter
              filters={filters}
              onFilterChange={handleFilterChange}
              onReset={handleResetFilters}
            />
          </CollapseCard>
        </>
        <CollapseCard title="Salary List">
          <SalesMasterList
            list={filterEmp}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default SalaryMasterPage;
